import { useState } from "react";
import { User } from "../../app/backendTypes";
import ToolsOverview from "../common/tools/ToolsOverview";
import DisplayUser from "../common/users/DisplayUser";
import EmployeePicker from "./EmployeePicker";
import { useSearchParams } from "react-router-dom";

function Employees() {
  const [employee, setEmployee] = useState<User | null>(null);

  const [searchParams, setSearchParams] = useSearchParams();
  const id = parseInt(searchParams.get("id") || "");

  return (
    <>
      <EmployeePicker
        onChange={(val) => {
          setEmployee(val);

          if (val === null) setSearchParams({});
          else if (id !== val.employee.id)
            setSearchParams({ id: val.employee.id.toString() });
        }}
        onLoad={(val) => {
          setEmployee(val);

          if (val === null) setSearchParams({});
          else if (id !== val.employee.id)
            setSearchParams({ id: val.employee.id.toString() });
        }}
        initialValue={employee?.employee.id || id}
      />
      {employee !== null && (
        <>
          <DisplayUser user={employee} />
          <ToolsOverview user={employee} />
        </>
      )}
      <br />
    </>
  );
}

export default Employees;
